module.exports = __webpack_public_path__ + "img/6spades.83f57517.jpg";